import script from "./IndiceIpcaRepository.vue?vue&type=script&lang=js"
export * from "./IndiceIpcaRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__